// basic usage:
// trackLoadTask("taskName", TYPE.Start)
// trackLoadTaskStart("taskName")
// trackLoadTaskEnd("taskName")
// Module handles tracking time between these two entirely; so will need a .init

import Game from '../Game';
import { FBTrackingEvent } from './Tracking/FBTrackingEvent';

export enum LoadEventType {
    Start,
    End
}

export enum LoadEvents {
    FB_preStartGame = "fb_psg",
    GB_loginFlow = "gb_lf",
    SOFA_miscLoading1 = "sofa_misc1",
    SOFA_miscLoading2 = "sofa_misc2",
    SOFA_worldSystemPreload = "sofa_wsp",
    SOFA_levelSystemPreload = "sofa_lsp"
}

interface ILoadtimeTrackerSettings {
    autoInit?: boolean
}

interface ILoadtimeTrackerTask {
    key: string;
    timeStarted: number;
    timeFinished: number | undefined;
}

/**
 * Where %k is the event key
 */
const TEMPLATE_STRING: string = "loadTime_%k";

const TRACKING_THRESHOLDS = [
    1500,
    4000,
    7000
];

const DEFAULT_SETTINGS: ILoadtimeTrackerSettings = {
    autoInit: false,

}

class LoadtimeTracker {

    private _isInitialized: boolean = false;

    private _tasks: Array<ILoadtimeTrackerTask> = [];

    constructor(_settings: ILoadtimeTrackerSettings) {

        if(!_settings.autoInit) {
            this.init();
        }
    }

    public init(): Promise<void> {
        this._isInitialized = true;
        return Promise.resolve();
    }

    public trackLoadTask(_key: LoadEvents, _type: LoadEventType): void {
    }

    private static sendEvent(_task: ILoadtimeTrackerTask): void {
    }

    private static logToConsole(str: string): void {
        console.log(`[LoadtimeTracker] ${str}`);
    }

    private findTaskByKey(_key: string) {
        return this._tasks.find((e: ILoadtimeTrackerTask) => e.key === _key);
    }

    private static getCurrentTimestamp(): number {
        // todo: make more accurate?
        return Date.now();
    }

}

export const LoadtimeTrackerSingleton = new LoadtimeTracker(DEFAULT_SETTINGS);
